import searchHandler from './modules/searchHandler';
import mobmenuHandler from './modules/mobmenuHandler';
import backToTopHandler from './modules/backToTopHandler';
import faqHandler from './modules/faqHandler';
import showMoreOffersHandler from './modules/showMoreOffersHandler';

document.addEventListener("DOMContentLoaded", () => {

    'use strict';

    searchHandler();
    mobmenuHandler(".menu-mob", ".menu-primary");
    backToTopHandler();
    faqHandler();
    showMoreOffersHandler();

});